import * as React from 'react'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { ToggleSortIcon } from '../../atoms/search/ToggleSortIcon'
import { SubLabel, TableHead, TableHeading } from '../../atoms/Table'
import { CompaniesSortCondition, SortType } from './CompaniesTable'

export const CompaniesTableHead: React.FC<{
  sort?: CompaniesSortCondition
  sticky?: boolean
  offset?: string
  withTotalFunding: boolean
  onToggleSort?: (field: SortType) => void
}> = ({
  sort,
  sticky,
  offset,
  withTotalFunding: totalFunding,
  onToggleSort,
}) => {
  return (
    <TableHead sticky={sticky} offset={offset}>
      <tr
        css={css`
          > th {
            background-color: ${colors.white10};
          }
        `}
      >
        <TableHeading>企業名</TableHeading>
        <TableHeading>
          設立年月日
          {sort && (
            <ToggleSortIcon
              type={sort.key === 'established' ? sort.order : null}
              onClick={() => onToggleSort && onToggleSort('established')}
            />
          )}
        </TableHeading>
        <TableHeading align="center">
          <div>
            <div>最新ラウンド</div>
            <div>調達日</div>
          </div>
          {sort && (
            <ToggleSortIcon
              type={sort.key === 'lastFundraised' ? sort.order : null}
              onClick={() => onToggleSort && onToggleSort('lastFundraised')}
            />
          )}
        </TableHeading>
        <TableHeading
          align="center"
          help="スピーダが独自に定義する成長フェーズ"
          helpProps={{
            linkTo: process.env.INITIAL_SERIES_HELP_ENDPOINT,
            //ref: https://github.com/Japan-Venture-Research/penguin/pull/964
            offset: {
              top: sort ? 0 : 10,
            },
          }}
        >
          スピーダ
          <br />
          調達シリーズ
        </TableHeading>
        {totalFunding && (
          <TableHeading align="center">
            <div>
              <div>総調達額</div>
              <SubLabel>千円</SubLabel>
            </div>
            {sort && (
              <ToggleSortIcon
                type={sort.key === 'totalFunding' ? sort.order : null}
                onClick={() => onToggleSort && onToggleSort('totalFunding')}
              />
            )}
          </TableHeading>
        )}
        <TableHeading align="center">
          <div>
            <div>調達後評価額</div>
            <SubLabel>千円</SubLabel>
          </div>
          {sort && (
            <ToggleSortIcon
              type={sort.key === 'valuation' ? sort.order : null}
              onClick={() => onToggleSort && onToggleSort('valuation')}
            />
          )}
        </TableHeading>
      </tr>
    </TableHead>
  )
}
